<template>
    <section>

        <ContentLayer class="keyframe background" 
            v-if="keyframe.background" 
            :settings="settings"
            :content="keyframe" :level="'keyframe'" :layer="'background'"
            :structure="structure" :navigationData="navigationData" :active="active" 
            :key="'keyframe-' + chapter.uri + '-' + slide.uri + '-' + keyframe.uri + '-background'"/>

        <ContentLayer class="keyframe content" 
            v-if="keyframe.content" 
            :settings="settings"
            :content="keyframe" :level="'keyframe'" :layer="'content'"
            :structure="structure" :navigationData="navigationData" :active="active" 
            :key="'keyframe-' + chapter.uri + '-' + slide.uri + '-' + keyframe.uri + '-content'" />

        <ContentLayer class="keyframe foreground" 
            v-if="keyframe.foreground" 
            :settings="settings"
            :content="keyframe" :level="'keyframe'" :layer="'foreground'"
            :structure="structure" :navigationData="navigationData" :active="active" 
            :key="'keyframe-' + chapter.uri + '-' + slide.uri + '-' + keyframe.uri + '-foreground'" />

    </section>
</template>

<script>

import navigationMixin from '@/core/mixins/navigationMixin.js'

export default {
    data: () => {
        return {}
    },
    watch: {
        active(val) {
            if (val) this.onActivated()
        },
    },
    computed: {
        active() {
            return this.presentationIndex === this.currentPresentationIndex && 
                this.chapterIndex === this.currentChapterIndex && 
                this.slideIndex === this.currentSlideIndex &&
                this.keyframeIndex === this.currentKeyframeIndex
        },
        keyframe() {
            return this.slide.keyframes[this.keyframeIndex]
        }
    },
    mixins: [navigationMixin],
    props: ['settings', 'keyframeIndex', 'slideIndex', 'presentationIndex', 'chapterIndex', 'slide', 'chapter', 'structure', 'navigationData'],
    methods: {
        onActivated() {
            if (!this.settings.disableNavigationDebugLogging) console.log("keyframe: ", this.keyframe.uri)
        },
        initializeKeyframe() {
            this.$el.style.backgroundColor = this.settings.keyframeBackgroundColor
        }
    },
    created() {},
    mounted() {
        this.initializeKeyframe()
    }
}
</script>

<style scoped lang="scss">
    
    @import '~@/core/assets/scss/_variables.scss';

    .keyframe.background {
        z-index: 0;
    }

    .keyframe.content {
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        p {
            margin-top: 200px;
            background-color: #fff;
        }
    }

    .keyframe.foreground {
        z-index: 2;
        pointer-events: none;
    }
</style>